import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const MagicStarIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12 3.5L14.2 9.3C14.3 9.6 14.5 9.8 14.8 9.9L20.5 12L14.8 14.1C14.5 14.2 14.3 14.4 14.2 14.7L12 20.5L9.8 14.7C9.7 14.4 9.5 14.2 9.2 14.1L3.5 12L9.2 9.9C9.5 9.8 9.7 9.6 9.8 9.3L12 3.5Z"
		/>

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M19 2V5" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M17.5 3.5H20.5" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M5 19V22" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M3.5 20.5H6.5" />
	</SvgIcon>
)

export default MagicStarIconAtom
